import JobFunnelProjectDashboard from './JobFunnelProjectDashboard';
import JobFunnelProjectDashboardV2 from './JobFunnelProjectDashboardV2';
import { useFeatureFlag } from '../../contexts/FeatureFlagsProvider';

/**
 * Point d'entrée de la route `/jobs`. Bascule entre la nouvelle liste « Gestion des jobs » V2
 * (feature flag `jobsDashboardV2`) et la V1 historique. Par défaut : V1. Le flag est lu au render
 * (contexte), donc l'activer dans les Paramètres bascule sans rebuild.
 */
const JobsRoutePage = () => {
  const jobsDashboardV2 = useFeatureFlag('jobsDashboardV2');
  return jobsDashboardV2 ? <JobFunnelProjectDashboardV2 /> : <JobFunnelProjectDashboard />;
};

export default JobsRoutePage;
